import { MediaQueries } from 'custom_hooks/useWindowSize';
import { DashboardPageLayout } from 'pages/Dashboard/components/styled';
import styled from 'styled-components';

// Re-export shared components
export {
    Card,
    CardContent,
    CardTitle,
    Header,
    HeaderControls,
    StyledLocationsMultiSelect,
} from 'pages/Dashboard/components/styled';

/**
 * DeskActivityOverview specific grid layout
 */
export const Page = styled(DashboardPageLayout)`
    display: grid;
    grid-template-areas:
        'head head head head head'
        'fault-types fault-types    asset-faults   asset-faults   asset-faults'
        'engagement  open-vs-closed open-vs-closed open-vs-closed activity-types';
    // if you want to lock this to the screen, remove the minmax and just do 'fr's
    grid-template-rows: var(--dashboard-header-height) minmax(42rem, 3fr) minmax(
            42rem,
            3fr
        );
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

    .fault-types {
        grid-area: fault-types;
    }

    .asset-faults {
        grid-area: asset-faults;
    }

    .engagement {
        grid-area: engagement;
    }

    .open-vs-closed {
        grid-area: open-vs-closed;
    }

    .activity-types {
        grid-area: activity-types;
    }

    /* Responsive layout for narrow screens */
    @media ${MediaQueries.xlargeAndDown} {
        grid-template-areas:
            'head'
            'fault-types'
            'asset-faults'
            'engagement'
            'open-vs-closed'
            'activity-types';
        grid-template-columns: 1fr;
        grid-template-rows: auto;

        .fault-types {
            min-height: 40rem;
        }

        .asset-faults {
            min-height: 40rem;
        }

        .engagement {
        }

        .open-vs-closed {
            min-height: 40rem;
        }

        .activity-types {
            min-height: 40rem;
        }
    }
`;
